import React, { useEffect, useState } from "react";
import axios from "axios";
import TableComponent from "../components/TableComponent";
import { Container, Button } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { formatDate } from "../utils/helpers";
import { Modal, Form } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
const API_URL = process.env.REACT_APP_API_URL;



function Literature_Avenue_List() {


    const [data_entry, setDataEntry] = useState([]);
    const navigate = useNavigate();

    const { user } = useAuth();
    ///////////////////////////
    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [error, setError] = useState("");
    ////////////////////////////
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return;

        axios.get(`${API_URL}/literature_avenue_list`, { headers: { Authorization: `Bearer ${token}` } })
            .then(res => setDataEntry(res.data.literatures || []))
            .catch(err => console.error(err));
    }, []);

    console.log(data_entry);
    const handleEdit = (id) => navigate(`/Literature_Avenue_Edit/${id}`);




    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure?")) return;

        const token = localStorage.getItem("token");

        try {
            const res = await axios.delete(`${API_URL}/delete_literature_avenue/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (res.data.status) {
                setDataEntry(data_entry.filter(u => u.data_id !== id));

                alert(res.data.message);
            } else {
                alert(res.data.message || res.data.error || "Failed to delete");
            }
        } catch (err) {
            console.error(err);
            alert("An error occurred while deleting the record");
        }
    };



    const openPasswordModal = (literature_id) => {
        setSelectedId(literature_id);
        setPassword("");
        setError("");
        setShowModal(true);
    };


    const verifyPassword = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/verify-password`,
                { password, uid: user?.uid },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (res.data.success) {
                setShowModal(false);

                handleDelete(selectedId);
            } else {
                setError("Incorrect password");
            }
        } catch (err) {
            setError("Incorrect password");
        }
    };





    const columns = [
        { key: "index", label: "Sr.no", format: (_, __, index) => index + 1 },
        { key: "literature_name", label: "Literature Name", align: "left" },
        { key: "center_name/center_code", label: "Center Name /Code", format: (_, row) => `${row.center_name} / ${row.center_code}` },
        { key: "created_by", label: "Created By" },
        { key: "created_date", label: "Created Date", format: formatDate },
        {
            key: "action",
            label: "Action",
            format: (_, row) => (
                <>
                    <Button size="sm" className="me-2" onClick={() => handleEdit(row.id)}>Edit</Button>
                    <Button size="sm" variant="danger" onClick={() => openPasswordModal(row.id)}>Delete</Button>
                </>
            )
        }
    ];










    return (
        <Container className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Literature Avenue List</h3>

                <Link className="btn btn-sm btn-primary" to="/Literature_Avenue">Add New Data</Link>

            </div>
            <TableComponent columns={columns} data={data_entry} rowsPerPage={10} maxHeight={400} headerClass="table-dark" />



            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                backdrop="static"
                keyboard={false}
                dialogClassName="soft-modal"
            >
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontWeight: 600, fontSize: "1.3rem" }}>
                        Confirm Password
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: "2rem 2rem 1rem 2rem" }}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500, fontSize: "0.95rem", color: "#555" }}>
                            Enter your password
                        </Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="" autoComplete="off"
                            style={{
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                                padding: "10px 15px",
                                fontSize: "0.95rem",
                                boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                            }}
                        />
                    </Form.Group>
                    {error && (
                        <p
                            className="text-danger mt-2"
                            style={{ fontSize: "0.9rem", fontWeight: 500 }}
                        >
                            {error}
                        </p>
                    )}
                </Modal.Body>

                <Modal.Footer style={{ borderTop: "none", padding: "1rem 2rem 2rem 2rem" }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setShowModal(false)}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 18px",
                            fontWeight: 500,
                            boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={verifyPassword}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 20px",
                            fontWeight: 600,
                            background: "linear-gradient(135deg,#6a9fff,#5a86ff)",
                            border: "none",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        }}
                    >
                        Verify
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>

    );
}


export default Literature_Avenue_List;